"use client";

import { ArrowDown, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Pagination, PaginationContent, PaginationItem, PaginationLink } from "@/components/ui/pagination";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VibrantTransformations() {
  const galleryItems = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/interior_living_room_fresh_paint.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/interior_living_room_fresh_paint.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/interior_living_room_fresh_paint.png-wvc-sizes",
    alt: "Living room with freshly painted walls in soft light",
    title: "the living space",
    meta: "RESIDENTIAL \u00B7 INTERIOR",
    aspect: "aspect-[3/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_modern_home_facade.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_modern_home_facade.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_modern_home_facade.png-wvc-sizes",
    alt: "Modern home exterior with professional paint finish",
    title: "the curb appeal",
    meta: "RESIDENTIAL \u00B7 EXTERIOR",
    aspect: "aspect-[16/10]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/detail_brush_stroke_texture.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/detail_brush_stroke_texture.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/detail_brush_stroke_texture.png-wvc-sizes",
    alt: "Close up of professional brush stroke texture",
    title: "the fine detail",
    meta: "CRAFT \u00B7 PRECISION",
    aspect: "aspect-square"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/bedroom_calm_neutral_tones.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/bedroom_calm_neutral_tones.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/bedroom_calm_neutral_tones.png-wvc-sizes",
    alt: "Bedroom painted in calm neutral tones",
    title: "the restful retreat",
    meta: "INTERIOR \u00B7 BEDROOM",
    aspect: "aspect-[3/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/kitchen_cabinet_refinishing.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/kitchen_cabinet_refinishing.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/kitchen_cabinet_refinishing.png-wvc-sizes",
    alt: "Kitchen cabinets with professional finish",
    title: "the kitchen refresh",
    meta: "CABINETRY \u00B7 FINISH",
    aspect: "aspect-[16/10]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/entryway_bright_welcoming_hall.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/entryway_bright_welcoming_hall.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/entryway_bright_welcoming_hall.png-wvc-sizes",
    alt: "Bright and welcoming painted entryway",
    title: "the grand entrance",
    meta: "INTERIOR \u00B7 FOYER",
    aspect: "aspect-square"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_trim_work_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_trim_work_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_trim_work_detail.png-wvc-sizes",
    alt: "Detailed exterior trim painting work",
    title: "the crisp edge",
    meta: "EXTERIOR \u00B7 TRIM",
    aspect: "aspect-[3/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/home_office_productive_color.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/home_office_productive_color.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/home_office_productive_color.png-wvc-sizes",
    alt: "Home office with professional paint job",
    title: "the focused space",
    meta: "INTERIOR \u00B7 OFFICE",
    aspect: "aspect-[16/10]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/dining_room_accent_wall.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/dining_room_accent_wall.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/dining_room_accent_wall.png-wvc-sizes",
    alt: "Dining room with a bold accent wall",
    title: "the statement wall",
    meta: "INTERIOR \u00B7 DESIGN",
    aspect: "aspect-square"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_deck_staining.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_deck_staining.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/exterior_deck_staining.png-wvc-sizes",
    alt: "Professionally stained outdoor deck",
    title: "the outdoor living",
    meta: "EXTERIOR \u00B7 DECK",
    aspect: "aspect-[3/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/bathroom_moisture_resistant_paint.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/bathroom_moisture_resistant_paint.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/bathroom_moisture_resistant_paint.png-wvc-sizes",
    alt: "Bathroom with moisture resistant paint finish",
    title: "the clean finish",
    meta: "INTERIOR \u00B7 BATH",
    aspect: "aspect-[16/10]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/full_home_exterior_transformation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/full_home_exterior_transformation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/full_home_exterior_transformation.png-wvc-sizes",
    alt: "Full home exterior transformation",
    title: "the total transformation",
    meta: "EXTERIOR \u00B7 FULL",
    aspect: "aspect-square"
  }];
  const intro = useRevealOnScroll<HTMLDivElement>();
  const interlude1 = useRevealOnScroll<HTMLDivElement>();
  const interlude2 = useRevealOnScroll<HTMLDivElement>();
  const firstBatch = galleryItems.slice(0, 6);
  const secondBatch = galleryItems.slice(6, 12);
  return <section data-section-id="2746" id="vibrant-transformations" className="bg-background text-foreground">
      <div className="mx-auto max-w-[1400px] px-6 pt-24 pb-24 sm:px-8 lg:px-12 lg:pt-28">
        {}
        <div ref={intro.ref} className={`grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-end transition-all duration-700 ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground" style={{
            color: "var(--muted-foreground)"
          }}>
              Portfolio <span className="mx-2">&middot;</span> 24 Projects
            </p>
            <h2 className="mt-6 font-serif font-default text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-[3rem]">
              Perfect <em className="italic font-light">lines</em>. Lasting{" "}
              <em className="italic font-light">beauty</em>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-default text-base leading-relaxed text-muted-foreground sm:text-lg" style={{
            color: "var(--muted-foreground)"
          }}>
              A curated collection of residential transformations &mdash; where
              precision meets premium paint to redefine your home's character.
            </p>
          </div>
        </div>

        {}
        <div className="mt-16 columns-1 gap-6 sm:columns-2 lg:columns-3 lg:gap-7 xl:columns-4 xl:gap-8">
          {firstBatch.map((item, i) => <figure data-index={i} key={item.title} className="group relative mb-6 break-inside-avoid lg:mb-7 xl:mb-8">
              <div className={`relative overflow-hidden rounded-lg shadow-md ${item.aspect}`}>
                <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />
                {}
                <figcaption className="pointer-events-none absolute inset-x-3 bottom-3 flex items-end justify-between gap-3 rounded-lg bg-background/90 px-4 py-3 opacity-0 transition-opacity duration-500 ease-out group-hover:opacity-100 sm:inset-x-4 sm:bottom-4 sm:px-5 sm:py-4">
                  <div className="min-w-0">
                    <p className="font-serif text-lg italic leading-tight text-foreground sm:text-xl">
                      {item.title}
                    </p>
                    <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground" style={{
                  color: "var(--muted-foreground)"
                }}>
                      {item.meta}
                    </p>
                  </div>
                  <Button asChild variant="outline" size="sm" className="pointer-events-auto h-9 shrink-0 gap-1.5 rounded-lg border-primary/30 bg-transparent px-3 font-serif italic text-foreground hover:bg-primary hover:text-white">
                    <Link to="/GalleryPage">
                      view <Plus className="size-3.5" />
                    </Link>
                  </Button>
                </figcaption>
              </div>
            </figure>)}
        </div>

        {}
        <div ref={interlude1.ref} className={`my-16 flex items-center gap-6 sm:my-20 lg:my-24 transition-all duration-700 ease-out ${interlude1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="h-px flex-1 bg-foreground/20" aria-hidden="true"></span>
          <p className="text-center font-serif font-default italic text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl" style={{
          color: "var(--chart-3)"
        }}>
            every wall tells a story of quality.
          </p>
          <span className="h-px flex-1 bg-foreground/20" aria-hidden="true"></span>
        </div>

        {}
        <div className="columns-1 gap-6 sm:columns-2 lg:columns-3 lg:gap-7 xl:columns-4 xl:gap-8">
          {secondBatch.map((item, i) => <figure data-index={i} key={item.title} className="group relative mb-6 break-inside-avoid lg:mb-7 xl:mb-8">
              <div className={`relative overflow-hidden rounded-lg shadow-md ${item.aspect}`}>
                <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />
                <figcaption className="pointer-events-none absolute inset-x-3 bottom-3 flex items-end justify-between gap-3 rounded-lg bg-background/90 px-4 py-3 opacity-0 transition-opacity duration-500 ease-out group-hover:opacity-100 sm:inset-x-4 sm:bottom-4 sm:px-5 sm:py-4">
                  <div className="min-w-0">
                    <p className="font-serif text-lg italic leading-tight text-foreground sm:text-xl">
                      {item.title}
                    </p>
                    <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground" style={{
                  color: "var(--muted-foreground)"
                }}>
                      {item.meta}
                    </p>
                  </div>
                  <Button asChild variant="outline" size="sm" className="pointer-events-auto h-9 shrink-0 gap-1.5 rounded-lg border-primary/30 bg-transparent px-3 font-serif italic text-foreground hover:bg-primary hover:text-white">
                    <Link to="/GalleryPage">
                      view <Plus className="size-3.5" />
                    </Link>
                  </Button>
                </figcaption>
              </div>
            </figure>)}
        </div>

        {}
        <div ref={interlude2.ref} className={`my-16 flex items-center gap-6 sm:my-20 lg:my-24 transition-all duration-700 ease-out ${interlude2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="h-px flex-1 bg-foreground/20" aria-hidden="true"></span>
          <p className="text-center font-serif font-default italic text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl" style={{
          color: "var(--chart-3)"
        }}>
            excellence is in the final coat.
          </p>
          <span className="h-px flex-1 bg-foreground/20" aria-hidden="true"></span>
        </div>

        {}
        <div className="mt-20 flex flex-col items-center gap-10">
          <Pagination>
            <PaginationContent className="gap-6 sm:gap-10">
              <PaginationItem data-index={0}>
                <PaginationLink href="#" isActive className="h-auto w-auto rounded-lg border-0 bg-transparent px-2 font-serif font-default text-2xl italic text-foreground hover:bg-transparent data-[active=true]:border-0 data-[active=true]:bg-transparent data-[active=true]:underline data-[active=true]:underline-offset-8">
                  01
                </PaginationLink>
              </PaginationItem>
              <PaginationItem data-index={1}>
                <PaginationLink href="#" className="h-auto w-auto rounded-lg bg-transparent px-2 font-serif font-default text-2xl italic text-muted-foreground hover:bg-transparent hover:text-foreground">
                  02
                </PaginationLink>
              </PaginationItem>
              <PaginationItem data-index={2}>
                <PaginationLink href="#" className="h-auto w-auto rounded-lg bg-transparent px-2 font-serif font-default text-2xl italic text-muted-foreground hover:bg-transparent hover:text-foreground">
                  03
                </PaginationLink>
              </PaginationItem>
              <PaginationItem data-index={3}>
                <PaginationLink href="#" className="h-auto w-auto rounded-lg bg-transparent px-2 font-serif font-default text-2xl italic text-muted-foreground hover:bg-transparent hover:text-foreground">
                  04
                </PaginationLink>
              </PaginationItem>
            </PaginationContent>
          </Pagination>

          <span className="block h-px w-40 bg-foreground/25" aria-hidden="true"></span>

          <Button asChild variant="link" className="h-auto gap-2 p-0 font-serif font-default text-lg italic text-foreground hover:no-underline">
            <Link to="/GalleryPage">
              Load more projects <ArrowDown className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}